import { createSlice } from '@reduxjs/toolkit';

const roleSlice = createSlice({
	name: 'role',
	initialState: {
		currentRole: null,
	},
	reducers: {
		setCurrentRole: (state, action) => {
			state.currentRole = action.payload;
		},
	},
});
export const { setCurrentRole } = roleSlice.actions;
export default roleSlice.reducer;
